import React, { useRef } from "react"
import { UploaderComponent } from '@syncfusion/ej2-react-inputs'
import { detach, L10n } from '@syncfusion/ej2-base'
import appointments from "../../configurations/appointments";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@mui/material/Alert";
import { useTranslation } from "react-i18next";
import { isEmptyObject } from '../utils';

export const DragNDropUploader = props => {
    let uploadObj = useRef(null);
    let target
    // let asyncSettings = {
    //     saveUrl: appointments.baseURL + "/FileReader/Upload",
    //     removeUrl: appointments.baseURL + "/FileReader/RemoveFile",
    // }
    let asyncSettings = {
        saveUrl: appointments.baseURL + props.endpoint,
        removeUrl: appointments.baseURL + "/FileReader/RemoveFile",
    }
    const allowedExtensions = props.allowedExtensions || ".csv, .xlsx";
    let dropContainerRef;
    let dropContainerEle;

    dropContainerEle = null;
    dropContainerRef = element => {
        dropContainerEle = element;
    };

    L10n.load({
        'pt-BR': {
            'uploader': {
                'dropFilesHint': 'ou arraste os arquivos aqui'
            }
        }
    });

    const { t } = useTranslation();

    const onUploadSuccess = args => {
        let responseData = ""
        if (args.response.headers.includes('content-type')) {
            if (args.response.headers.includes('date:')) {
                responseData = args.response.headers.split("content-type: ")[1].split("date:")[0]
            } else {
                responseData = args.response.headers.split("content-type: ")[1]
            }
        }

        if (args.operation === "upload") {
            props.uploadCallBack(args);
        }
    }
    const onUploadFailed = args => {
        let responseData = ""
        if (args.response.headers.includes('content-type')) {
            if (args.response.headers.includes('date:')) {
                responseData = args.response.headers.split("content-type: ")[1].split("date:")[0]
            } else {
                responseData = args.response.headers.split("content-type: ")[1]
            }
        }

        props.uploadCallBack(args);
    }

    // const onSelect = args => {
    //     let allowedTypes = ['xml', 'csv', 'xlsx', 'xls'];
    //     let modifiedFiles = [];
    //     for (let file of args.filesData) {
    //         if (allowedTypes.indexOf(file.type.toLowerCase()) > -1) {
    //             modifiedFiles.push(file);
    //         }
    //     }
    //     if (modifiedFiles.length > 0) {
    //         args.isModified = true;
    //         args.modifiedFiles = modifiedFiles;
    //     } else {
    //         args.cancel = true;
    //         props.open(true);
    //     }
    // }

    const onSelect = args => {
        const allowedTypes = props.allowedTypes || [
            "xml",
            "csv",
            "xlsx",
            "xls"
        ];

        const modifiedFiles = [];

        for (const file of args.filesData) {
            if (allowedTypes.includes(file.type.toLowerCase())) {
                modifiedFiles.push(file);
            }
        }

        if (modifiedFiles.length > 0) {
            args.isModified = true;
            args.modifiedFiles = modifiedFiles;
        } else {
            args.cancel = true;

            if (typeof props.open === "function") {
                props.open(true);
            }
        }
    };

    const onRemoveFile = args => {
        args.postRawFile = false;
    }

    const onUploading = (args) => {
        console.log("Dados adicionais enviados:", props.aditionalData);

        args.customFormData = props.aditionalData || [];
    };

    return (
        <>
            <div className='control-pane' ref={dropContainerRef}>
                <div className='col-lg-12 control-section upload-custom'>
                    <div id="upload_wrapper">
                        {/* Render Uploader */}
                        <UploaderComponent id='UploadFiles' type='file'
                            ref={uploadObj}
                            asyncSettings={asyncSettings}
                            selected={onSelect}
                            uploading={onUploading}
                            removing={onRemoveFile}
                            success={onUploadSuccess}
                            failure={onUploadFailed}
                            allowedExtensions={allowedExtensions}
                            multiple={true}
                            autoUpload={false}
                            dropArea={target}
                            buttons={{ browse: "Buscar", clear: "Limpar", upload: "Carregar" }}
                            locale="pt-BR"
                        >
                        </UploaderComponent>
                    </div>
                </div>
            </div>
        </>
    )
}